import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "emailnotifications-24-px_7e6827e392a0add3c49299dc7022cdc3",
  "use": "emailnotifications-24-px_7e6827e392a0add3c49299dc7022cdc3-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"emailnotifications-24-px_7e6827e392a0add3c49299dc7022cdc3\">\n    <path fill-rule=\"evenodd\" d=\"M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6.5-6v-5.5c0-3.1-2.1-5.6-5-6.3v-.7c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5v.7c-2.9.7-5 3.2-5 6.3V16l-2 2v1h17v-1l-2-2z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol